export enum Acl {

  OPERACIONES = "073",
  DOCUMENTACION = "074",
  CONTROL_DOCUMENTARIO = "075",
  PLAZOS = "076",
  CITAS = "079",
  CANALES = "080",
  BOOKING = "106",
  GESTION = "081",
  DATOS_FINALES = "077",
  STATUS_DOCUMENTARIO = "078",

}
